import { FlowObjectDefinition } from '../models/flow-object.model';

export class VisibleArea {
    flowDefinitionDetails = false;
    flowDefinitionDetailsHotConfigs = false;
    flowObjectDetails = false;
    formBuilder = false;
    formBuilderInboundApi = false;
    htmlEditor = false;
    api = false;
    midApi = false;
    gatewayRules = false;
    gatewayPaths = false;
    extraContent = false;
}

export class OnAfterSelectFlowObjectDto {
    shouldMoveGroupingBackwards: boolean;
    flowObject?: FlowObjectDefinition;
}
